import React from 'react';

import { Wrap } from './styled';

import { H3, Text } from '@components/Typography';
import { ReactComponent as SuccessImg } from '@assets/icons/success-registration.svg';
import { NavLink } from '@components/Buttons';
import { LOGIN } from '@utils/paths';

const Success = (props: any) => {
  const { onClose, title, text, back } = props;
  return (
    <Wrap data-test="success-wrap">
      <H3>{title}</H3>
      <div>
        <Text size="large">{text}</Text>
      </div>
      <SuccessImg style={{ maxWidth: '40%' }} />
      <NavLink
        to={LOGIN}
        onClick={() => {
          return onClose();
        }}
      >
        {back}
      </NavLink>
    </Wrap>
  );
};

export default Success;
